import React from 'react';
import RadioButton from '../../common/radio-button/radio-button';
import './sync-install-updates-section.scss';
import { SyncMapStatus } from '../../../views/sync-maps-updates-view/hooks/use-syncs-maps-status-updates';
import maintenance from '../../../assets/maintenance.svg';
import wifi from '../../../assets/wifi.svg';
import usb from '../../../assets/usb.svg';

interface Props {
    setSelectedOption: (event: any) => void;
    syncMapsContent: SyncMapStatus;
    selectedOption: string;
    genId: string;
    version?: boolean;
    isCtr?: boolean;
    isVw?: boolean;
}

const SyncInstallUpdatesSection = (props: Props) => {
    const wifiValue = 'wifi';
    const usbValue = 'usb';
    const dealerValue = 'dealer';
    const eventName = 'sync-update-type';
    return (
        <section
            className="sync-install-updates-section"
            data-testid="sync-install-updates-section"
        >
            <h3 className="sync-radio-title">
                {props.syncMapsContent.syncUpdateSelectorTitle}
            </h3>
            {props.version || props.isCtr ? (
                <div className="sync-maps-radio-buttons">
                    <RadioButton
                        data-testid="versionTrueSyncWifi"
                        value={wifiValue}
                        label={props.syncMapsContent.syncWifiLabel}
                        checked={props.selectedOption === wifiValue}
                        imageNode={wifi}
                        onChange={() => props.setSelectedOption(wifiValue)}
                        eventName={eventName}
                        eventValue="wifi"
                    />

                    <RadioButton
                        data-testid="versionTrueSyncUsb"
                        value={usbValue}
                        label={props.syncMapsContent.syncUsbLabel}
                        checked={props.selectedOption === usbValue}
                        imageNode={usb}
                        onChange={() => props.setSelectedOption(usbValue)}
                        eventName={eventName}
                        eventValue="usb drive"
                    />
                </div>
            ) : (
                <div className="sync-maps-radio-buttons">
                    {props.genId === '3' && (
                        <RadioButton
                            value={wifiValue}
                            label={props.syncMapsContent.syncWifiLabel}
                            checked={props.selectedOption === wifiValue}
                            imageNode={wifi}
                            onChange={() => props.setSelectedOption(wifiValue)}
                            eventName={eventName}
                            eventValue="wifi"
                        />
                    )}
                    {(props.genId === '3' ||
                        props.genId === '2' ||
                        props.genId === '1' ||
                        props.isVw) && (
                        <RadioButton
                            value={usbValue}
                            label={props.syncMapsContent.syncUsbLabel}
                            checked={props.selectedOption === usbValue}
                            imageNode={usb}
                            onChange={() => props.setSelectedOption(usbValue)}
                            eventName={eventName}
                            eventValue="usb drive"
                        />
                    )}
                    <RadioButton
                        value={dealerValue}
                        label={props.syncMapsContent.syncDealerLabel}
                        checked={props.selectedOption === dealerValue}
                        imageNode={maintenance}
                        onChange={() => props.setSelectedOption(dealerValue)}
                        eventName={eventName}
                        eventValue="find a dealer"
                    />
                </div>
            )}
        </section>
    );
};

export default SyncInstallUpdatesSection;
